


































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Calendar, DropdownMenu, DropdownItem, TreeSelect, Checkbox, CheckboxGroup, Field, Overlay } from "vant";
import bottonBar from "@/components/bottonBar.vue";
import * as _ from "lodash";
import baseService from "@/service/baseService";
import btripServcice from "@/service/btripServcice";
import hotelPolicyService from "@/service/hotelPolicyService";
import UserService from "@/service/UserService";
import dataShare from "../dataShare";
import { categoryMap, YesOrNo } from "@/model/Base";
import { clone, values } from "lodash";
import riskTips from "../modules/riskDialog.vue";
import { isOfw } from "@/utils/utils";
const servicTypes: any = {
  HotelService: 1407,
  FlightService: 1409,
  TrainService: 1470,
};
@Component({
  components: {
    [Calendar.name]: Calendar,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Field.name]: Field,
    bottonBar,
    [Overlay.name]: Overlay,
    riskTips,
  },
})
export default class extends Vue {
  //porps
  @Prop()
  DepartDate!: string;

  @Prop()
  ArriveDate!: string;

  @Prop()
  departTime!: string;

  @Prop()
  departName!: string;

  @Prop()
  arriveName!: string;

  @Prop()
  filterData!: object;
  get isOfwApp() {
    return isOfw();
  }
  //data
  dataShare = dataShare;
  isShow = false;
  isRoundTrip = false;
  isShowCalendar = false;
  date = "";
  // price = 0;
  componentName = "";
  items = [
    {
      text: this.$root.$t("mall_modules_productlist_hangzhengqu") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
      ],
      id: 0,
    },
    {
      text: this.$root.$t("mall_modules_productlist_shangyequ") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
      ],
      id: 1,
    },
    {
      text: this.$root.$t("mall_modules_productlist_jiage") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
        {
          text: this.$root.$t("mall_modules_productlist_yixia") as string,
          id: "0-150",
        },
        {
          text: "¥ 150-300",
          id: "150-300",
        },
        {
          text: "¥ 300-450",
          id: "300-450",
        },
        {
          text: "¥ 450-600",
          id: "450-600",
        },
        {
          text: this.$root.$t("mall_modules_productlist_yishang") as string,
          id: "600-1000000",
        },
      ],
      id: 2,
    },
    {
      text: this.$root.$t("mall_modules_productlist_xingji") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
        {
          id: "0,1,2",
          text: this.$root.$t("mall_modules_productlist_erxingjijiyixia") as string,
          key: "svere",
        },
        {
          id: "3",
          text: this.$root.$t("mall_modules_productlist_sanxingjishushi") as string,
        },
        {
          id: "4",
          text: this.$root.$t("mall_modules_productlist_sixingjigaodang") as string,
        },
        {
          id: "5",
          text: this.$root.$t("mall_modules_productlist_wuxingjihaohua") as string,
        },
      ],
      id: 3,
    },
    {
      text: this.$root.$t("mall_modules_productlist_tese") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
      ],
      id: 4,
    },
    {
      text: this.$root.$t("mall_modules_productlist_fuwu") as string,
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
        },
      ],
      id: 5,
    },
  ];

  trainItems = [
    {
      text: this.$root.$t("mall_modules_productlist_chexingxuanze") as string,
      code: "trainType",
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
          mutex: true,
        },
        {
          text: this.$root.$t("mall_modules_productlist_gaotie") as string,
          id: "G/C",
        },
        {
          text: this.$root.$t("mall_modules_productlist_dongche") as string,
          id: "D",
        },
        {
          text: this.$root.$t("mall_modules_productlist_putong") as string,
          id: "Z/T/K",
        },
        {
          text: this.$root.$t("mall_modules_productlist_qitadeng") as string,
          id: this.$root.$t("mall_modules_productlist_qita") as string,
        },
      ],
    },
    {
      text: this.$root.$t("mall_modules_productlist_facheshijian") as string,
      code: "trainDate",
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
          mutex: true,
        },
        {
          text: "00:00-06:00",
          id: "00:00-06:00",
        },
        {
          text: "06:00-12:00",
          id: "06:00-12:00",
        },
        {
          text: "12:00-18:00",
          id: "12:00-18:00",
        },
        {
          text: "18:00-24:00",
          id: "18:00-24:00",
        },
      ],
    },
    {
      text: this.$root.$t("mall_modules_productlist_chalvzhengce") as string,
      code: "trainPolicy",
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
          mutex: true,
        },
        {
          text: this.$root.$t("mall_modules_productlist_fuhezhengce") as string,
          id: this.$root.$t("mall_modules_productlist_fuhezhengce") as string,
          mutex: true,
        },
        {
          text: this.$root.$t("mall_modules_productlist_weibeiguize") as string,
          id: this.$root.$t("mall_modules_productlist_weibeiguize") as string,
          mutex: true,
        },
      ],
    },
    {
      text: this.$root.$t("mall_modules_productlist_chufachezhan") as string,
      code: "fromStation",
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
          mutex: true,
        },
      ],
    },
    {
      text: this.$root.$t("mall_modules_productlist_daodachezhan") as string,
      code: "toStation",
      children: [
        {
          text: this.$root.$t("mall_modules_productlist_buxian") as string,
          id: 0,
          mutex: true,
        },
      ],
    },
  ];
  activeIds: any = 0;
  flightActiveIds: any = [0];
  trainActiveIds: any = [0];
  activeIndex = 0;
  standardValue: string = "";
  standardOptions: object[] = [
    {
      text: "显示全部",
      value: "",
    },
    {
      text: this.$root.$t("mall_hotel_hotellist_fuhezhengce") as string,
      value: true,
    },
    // {
    //   text: this.$root.$t("mall_hotel_hotellist_weibeiguize") as string,
    //   value: false,
    // },
  ];
  sortResult: string = "";
  sortResults: string = "";
  optionList: object[] = [
    // {
    //   text: this.$root.$t("mall_modules_productlist_zhinengpaixu") as string,
    //   value: "",
    // },
    {
      text: this.$root.$t("mall_modules_productlist_morenpaixu") as string,
      value: "",
    },
    {
      text: this.$root.$t("mall_modules_productlist_dijiayouxian") as string,
      value: "SalesPrice,ASC",
    },
    {
      text: this.$root.$t("mall_modules_productlist_gaojiayouxian") as string,
      value: "SalesPrice,DESC",
    },
    // {
    //   text: this.$root.$t("mall_modules_productlist_xingjiyouxian") as string,
    //   value: "ServiceLevel,ASC",
    // },
    // {
    //   text: this.$root.$t("mall_modules_productlist_putongyouxian") as string,
    //   value: "ServiceLevel, ",
    // },
  ];
  // optionLists: object[] = [
  //   {
  //     text: this.$root.$t("mall_modules_productlist_jiagexingji") as string,
  //     value: "",
  //   },
  //   {
  //     text: this.$root.$t("mall_modules_productlist_dijiayouxian") as string,
  //     value: "SalesPrice,ASC",
  //   },
  //   {
  //     text: this.$root.$t("mall_modules_productlist_gaojiayouxian") as string,
  //     value: "SalesPrice,DESC",
  //   },
  //   {
  //     text: this.$root.$t("mall_modules_productlist_xingjiyouxian") as string,
  //     value: "ServiceLevel,ASC",
  //   },
  //   {
  //     text: this.$root.$t("mall_modules_productlist_putongyouxian") as string,
  //     value: "ServiceLevel, ",
  //   },
  // ];
  timeSortResult: string = "";
  timeOptionList: object[] = [
    {
      text: this.$root.$t("mall_modules_productlist_shijianpaixu") as string,
      value: "",
    },
    {
      text: this.$root.$t("mall_modules_productlist_congzaodaowan") as string,
      value: "AirportDepartTime,asc", //z->w
    },
    {
      text: this.$root.$t("mall_modules_productlist_congwandaozao") as string,
      value: "AirportDepartTime,desc",
    },
  ];
  priceSortResult: string = "";
  priceOptionList: object[] = [
    {
      text: this.$root.$t("mall_modules_productlist_jiagepaixu") as string,
      value: "",
    },
    {
      text: this.$root.$t("mall_modules_productlist_congdidaogao") as string,
      value: "Price,asc", //z->w
    },
    {
      text: this.$root.$t("mall_modules_productlist_conggaodaodi") as string,
      value: "Price,desc",
    },
  ];
  flightFilters = {
    DepartAirport: "",
    ArrivalAirport: "",
    BtripRules: "",
    Transit: "",
    AirwayCode: "",
    DepartTime: "",
    ArrivalTime: "",
    AirportDepartTime: "asc",
    AirportArrivalTime: "",
    Price: "",
    Duration: "",
    ShareAirwayCode: "",
  };
  trainFilters = {
    trainType: "",
    trainDate: "",
    travelPolicy: "",
    fromStation: "",
    toStation: "",
  };
  flightLevelId = "";
  trainPolicy = "";
  defaultDate: any = new Date();
  hotelDate: any = [];
  isShowOverlay: boolean = false;
  TripRuleData = [];
  Continents = [];

  // //computed
  get serveType() {
    if (this.$route.name) {
      return (this.$route.name as any).replace("List", "");
    }
    return this.$route.meta.serviceCode;
  }

  get ServeType() {
    let serveType = this.serveType;
    let serviceType: string = "";
    if (serveType) {
      serviceType = serveType.replace(serveType[0], serveType[0].toUpperCase()) + "Service";
    }
    return servicTypes[serviceType];
  }

  get key() {
    return this.$route.path;
  }
  get markDepartDate() {
    if (this.$route.query.DepartDate) {
      return this.$route.query.DepartDate.toString().replace(/-/g, "/");
    }
  }
  get markArriveDate() {
    if (this.$route.query.ArriveDate) {
      return this.$route.query.ArriveDate.toString().replace(/-/g, "/");
    }
  }
  get VoyageType() {
    return this.$route.query.VoyageType;
  }
  get ZoneID() {
    let query = this.$route.query;
    if (query.ZoneID) {
      return query.ZoneID.toString();
    }
  }
  get AirwayList() {
    let AirwayList = [
      {
        text: this.$root.$t("mall_modules_productlist_buxian") as string,
        id: 0,
      },
    ];
    let list = _.map(this.dataShare.AirwayList, (item: any) => ({ text: item.AirwayName, id: item.AirwayCode }));
    return _.concat(AirwayList, list);
  }
  get ArriveAirportList() {
    let ArriveAirportList = [
      {
        text: this.$root.$t("mall_modules_productlist_buxian") as string,
        id: 0,
      },
    ];
    let list = _.map(this.dataShare.ArriveAirportList, (item: any) => ({ text: item.AirportName, id: item.AirportCode }));
    return _.concat(ArriveAirportList, list);
  }
  get DepartAirportList() {
    let DepartAirportList = [
      {
        text: this.$root.$t("mall_modules_productlist_buxian") as string,
        id: 0,
      },
    ];
    let list = _.map(this.dataShare.DepartAirportList, (item: any) => ({ text: item.AirportName, id: item.AirportCode }));
    return _.concat(DepartAirportList, list);
  }

  get flightItems() {
    let flightItems = [
      {
        text: this.$root.$t("mall_modules_productlist_qifeishijian") as string,
        children: [
          {
            text: this.$root.$t("mall_modules_productlist_buxian") as string,
            id: 0,
          },
          {
            text: "00:00-06:00",
            id: "0-6",
          },
          {
            text: "06:00-12:00",
            id: "6-12",
          },
          {
            text: "12:00-18:00",
            id: "12-18",
          },
          {
            text: "18:00-24:00",
            id: "18-24",
          },
        ],
      },
      {
        text: this.$root.$t("mall_modules_productlist_qifeijichang") as string,
        children: this.DepartAirportList,
      },
      {
        text: this.$root.$t("mall_modules_productlist_daodajichang") as string,
        children: this.ArriveAirportList,
      },
      {
        text: this.$root.$t("mall_modules_productlist_cangwei") as string,
        children: [
          {
            text: this.$root.$t("mall_modules_productlist_buxian") as string,
            id: 0,
          },
          {
            id: "1496",
            text: this.$root.$t("mall_modules_productlist_jingjicang") as string,
          },
          {
            id: "1498",
            text: this.$root.$t("mall_modules_productlist_shangwucang") as string,
          },
          {
            id: "1500",
            text: this.$root.$t("mall_modules_productlist_toudengcang") as string,
          },
        ],
      },
      {
        text: this.$root.$t("mall_modules_productlist_hangkonggongsi") as string,
        children: this.AirwayList,
      },
      {
        text: this.$root.$t("mall_modules_productlist_chalvzhengce") as string,
        children: [
          {
            text: this.$root.$t("mall_modules_productlist_buxian") as string,
            id: 3,
          },
          {
            text: this.$root.$t("mall_modules_productlist_fuhezhengce") as string,
            id: 0,
          },
          {
            text: this.$root.$t("mall_modules_productlist_weibeiguize") as string,
            id: 1,
          },
        ],
      },
    ];
    return flightItems;
  }

  get hotelKeyWords() {
    return dataShare.keyword.Keyword;
  }

  get isChange(): boolean {
    return this.$route.query.RuleType == "Change";
  }

  //mounted
  mounted() {
    this.date = (this as any).$moment().format("YYYY-MM-DD");
    // this.price = 600;
    this.componentName = this.serveType + "List";
    this.getZoneInfoList();
    this.getCityBusinessList();
    if (this.serveType == "hotel") {
      this.getThemesList("Themes");
      this.getThemesList("Facilities");
    }
    if (this.VoyageType == "1162" && this.markArriveDate) {
      this.defaultDate = [];
      this.defaultDate.push(new Date(this.markDepartDate!));
      this.defaultDate.push(new Date(this.markArriveDate));
    } else {
      this.defaultDate = new Date(this.markDepartDate!);
    }
    this.hotelDate.push(new Date(this.markDepartDate!));
    this.hotelDate.push(new Date(this.markArriveDate!));
    this.getTripRuleData();
    baseService
      .getZoneList({
        ZoneType: "1448",
      })
      .then(o => {
        if (o.isSucc) {
          this.Continents = o.result.entities;
        }
      });
  }
  getCategoryName(code: number) {
    let result: any = "";
    switch (code) {
      case 1127:
        result = this.$root.$t("mall_modules_producthome_guoji");
        break;
      case 1126:
        result = this.$root.$t("mall_modules_producthome_guonei");
        break;
      case 1409:
        result = this.$root.$t("mall_modules_producthome_jipiaofuwu");
        break;
      case 1407:
        result = this.$root.$t("mall_modules_producthome_jiudianfuwu");
        break;
      case 1470:
        result = this.$root.$t("mall_modules_producthome_huochefuwu");
        break;
      case YesOrNo.Yes:
        result = "是";
        break;
      case YesOrNo.No:
        result = "否";
        break;
      case 0:
        result = "不限制";
        break;
      case 1501:
        result = "相对最低价"; //, "相对最低价", "ControLowestPrice", 0),
        break;
      case 1502:
        result = "全天最低价"; //, "全天最低价", "DayLowestPrice", 0),
        break;
      case 1503:
        result = "时段最低价"; //, "时段最低价", "TimeAreaLowestPrice ", 0),
        break;
      case 1504:
        result = "航班最低价"; //, "全航班最低价", "FlightLowestPrice", 0),
        break;
    }
    return result;
  }

  //methods
  hotelFormatter(day?: any) {
    if (day.type === "start") {
      day.bottomInfo = "入住";
    } else if (day.type === "end") {
      day.bottomInfo = "离店";
    }
    return day;
  }
  flightFormatter(day?: any) {
    if (day.type === "start") {
      day.bottomInfo = "去程";
    } else if (day.type === "end") {
      day.bottomInfo = "返程";
    }
    return day;
  }
  handleSelectDate(dates: any) {
    this.isShowCalendar = false;
    let ConsumerDate = (this as any).$moment(dates[0]).format("YYYY-MM-DD");
    let FinishedDate = (this as any).$moment(dates[1]).format("YYYY-MM-DD");
    this.$emit("setNewData", ConsumerDate, FinishedDate);
  }
  sortChange(key: string, data: any) {
    if (key == "auto") {
      this.sortResults = "";
    }
    if (key == "sort") {
      this.sortResult = "";
    }
    const dataArr = data.split(",");
    const value: object = {
      code: dataArr[0],
      mode: dataArr[1],
    };
    this.$emit("getSort", value);
  }
  timeChange(data: any) {
    const value = {
      code: "",
      mode: "",
    };
    if (data != "") {
      const dataArr = data.split(",");
      value.code = dataArr[0];
      value.mode = dataArr[1];
    } else {
      value.code = "AirportDepartTime";
      value.mode = "";
    }
    this.priceSortResult = "";
    this.$emit("getSortData", value);
  }
  priceChange(data: any) {
    const value = {
      code: "",
      mode: "",
    };
    if (data != "") {
      const dataArr = data.split(",");
      value.code = dataArr[0];
      value.mode = dataArr[1];
    } else {
      value.code = "Price";
      value.mode = "";
    }
    this.timeSortResult = "";
    this.$emit("getSortData", value);
  }
  standardChange(value: any) {
    this.$emit("getFilters", "standard", value == "" ? null : false);
  }

  //获取行政区
  getZoneInfoList() {
    const data: any = { PageSize: 1000, ZoneType: "1449", ZoneUpper: this.ZoneID, Props: "ZoneID,ZoneName" };
    baseService.getZoneList(data).then(res => {
      if (res.isSucc) {
        const result = _.map(res.result.entities, item => ({ text: item.ZoneName, id: item.ZoneID }));
        _.forEach(this.items, item => {
          if (item.text == (this.$root.$t("mall_modules_productlist_hangzhengqu") as string)) {
            item.children = _.concat(item.children, result);
          }
        });
      }
    });
  }
  //获取商业区 / 商圈
  getCityBusinessList() {
    const data = { PageSize: 1000, CityID: this.ZoneID };
    hotelPolicyService.getCityBusiness(data).then(res => {
      if (res.isSucc) {
        const result = _.map(res.result, item => ({ text: item.BusinessName, id: item.BusinessId }));
        _.forEach(this.items, item => {
          if (item.text == (this.$root.$t("mall_modules_productlist_shangyequ") as string)) {
            item.children = _.concat(item.children, result);
          }
        });
      }
    });
  }
  //获取差旅标准
  getTripRuleData() {
    const query: any = this.$route.query;
    const Consumers = _.map(JSON.parse(query.Consumers), "ConsumerID");
    let data: any = {
      Users: Consumers,
      ApplyArea: query.ApplyArea,
      ServiceType: servicTypes[this.serveType.charAt(0).toUpperCase() + this.serveType.slice(1) + "Service"],
    };
    btripServcice.getTripRule(data).then(res => {
      (this as any).TripRuleData = res.result;
      this.getFlowInfo();
      this.$emit("getTripRuleData", res.result);
    });
  }

  FlowInfoData: any = "";
  getFlowInfo() {
    let __self = this;
    _.forEach((this as any).TripRuleData.Roles, (item: any) => {
      let FlowID = item.FlowID;
      UserService.getFlowInfo(FlowID).then(function(json) {
        if (json.isSucc) {
          let FlowInfo: any = json.result;
          _.forEach(FlowInfo.Nodes, (i: any) => {
            let RoleInfo: any = [];
            _.forEach(i.Roles, t => {
              let FlowRole = t;
              let roleinfo = {
                RoleID: FlowRole.RoleID,
              };
              UserService.getRoleInfo(roleinfo).then(role => {
                if (role.isSucc) {
                  RoleInfo.push(role.result);
                }
              });
            });
            i.RoleInfo = RoleInfo;
          });
          __self.FlowInfoData = json.result;
        }
      });
    });
  }
  filterRoleInfo(node?: any) {
    let Roles = _.filter(node.Roles, o => {
      return o.DutyCode == "executer";
    });
    let Actives: any = [];
    _.forEach(Roles, o => {
      _.forEach(node.RoleInfo, m => {
        if (o.RoleID == m.RoleID) {
          Actives.push(m);
        }
      });
    });
    return Actives;
  }
  ServiceGrades = {
    FlightGrades: [
      {
        GradeID: 1500,
        GradeTitle: this.$root.$t("mall_modules_producthome_toudengcang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_toudengcang") as string,
        GradeNum: 0,
        GradeDiscount: 20,
      },
      {
        GradeID: 1498,
        GradeTitle: this.$root.$t("mall_modules_producthome_shangwucang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_shangwucang") as string,
        GradeNum: 1,
        GradeDiscount: 15,
      },
      {
        GradeID: 1496,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 2,
        GradeDiscount: 10,
      },
      {
        GradeID: 1859,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang9zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 3,
        GradeDiscount: 9,
      },
      {
        GradeID: 1857,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang8zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 4,
        GradeDiscount: 8,
      },
      {
        GradeID: 1855,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang7zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 5,
        GradeDiscount: 7,
      },
      {
        GradeID: 1853,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang6zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 6,
        GradeDiscount: 6,
      },
      {
        GradeID: 1851,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang5zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 7,
        GradeDiscount: 5,
      },
    ],
  };
  filterServiceLevel(ServiceType?: any, ServiceLevels?: any) {
    let __self = this;
    if (!ServiceLevels) {
      return;
    }
    let datas = ServiceLevels.split(/\n|,/g);
    let results = [];
    if ((ServiceType = 1409)) {
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i];
        let result = _.find(this.ServiceGrades.FlightGrades, function(o) {
          return data == o.GradeID;
        });
        if (result) {
          results.push(result);
        }
      }
      let maxPrice = _.maxBy(results, function(o) {
        return o.GradeDiscount;
      });
      if (maxPrice) {
        return maxPrice.GradeTitle;
      }
    }
    if ((ServiceType = 1470)) {
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i];
        let result = categoryMap[data];
        if (result) {
          results.push(result);
        }
      }
      let maxPrice: any = _.minBy(results, (o: any) => {
        return o.CategoryID;
      });
      if (maxPrice) {
        return maxPrice.CategoryTitle;
      }
    }
  }
  filterPrice(ServiceType?: any, Prices?: any, ApplyArea?: any) {
    let __self = this;
    let results = [];
    if (ApplyArea == 1127) {
      let minPrice = _.minBy(Prices, (Price: any) => {
        return Price.LimitPrice;
      });
      let maxPrice = _.maxBy(Prices, (Price: any) => {
        return Price.LimitPrice;
      });
      if (minPrice.LimitPrice != maxPrice.LimitPrice) {
        if (ServiceType == 1409) {
          minPrice.RuleDescribe = (__self.contincentName(minPrice.LimitRule) + minPrice.LimitPrice + this.$root.$t("mall_modules_productlist_yinei")) as string;
          maxPrice.RuleDescribe = ((this.$root.$t("mall_modules_productlist_bufenhangxian") as string) + maxPrice.LimitPrice + this.$root.$t("mall_modules_productlist_yinei")) as string;
        } else {
          minPrice.RuleDescribe = (__self.contincentName(minPrice.LimitRule) + minPrice.LimitPrice + this.$root.$t("mall_modules_productlist_yinei")) as string;
          maxPrice.RuleDescribe = ((this.$root.$t("mall_modules_productlist_bufenjiudian") as string) + maxPrice.LimitPrice + this.$root.$t("mall_modules_productlist_yinei")) as string;
        }
        results.push(minPrice, maxPrice);
      } else {
        minPrice.RuleDescribe = maxPrice.LimitPrice;
        results.push(minPrice);
      }
      return results;
    } else {
      if (Prices.length > 0) {
        if (ServiceType == 1409) {
          Prices[0].RuleDescribe = Prices[0].LimitPrice;
        }
        if (ServiceType == 1407) {
          _.forEach(Prices, (o: any) => {
            o.RuleDescribe = this.$root.$t("mall_modules_productlist_jichengshiyinei", [o.LimitRule, o.LimitPrice]);
          });
        }
        return Prices;
      }
    }
  }
  contincentName(val?: any) {
    let __self = this;
    var contin: any = _.find(__self.Continents, (o: any) => o.ContinentID == val);
    if (contin) {
      if (contin.ContinentName == "" || contin.ContinentName == null) {
        return this.$root.$t("mall_modules_productlist_qita") as string;
      }
      return contin.ContinentName;
    }
    return "-";
  }
  //主题
  getThemesList(data: string) {
    hotelPolicyService.getThemeFacilityList(data).then(res => {
      if (res.isSucc) {
        const result = _.map(res.result, (item: any) => ({ text: item.name, id: item.value }));
        _.forEach(this.items, item => {
          if (data == "Themes" && item.text == (this.$root.$t("mall_modules_productlist_tese") as string)) {
            item.children = _.concat(item.children, result);
          } else if (data == "Facilities" && item.text == (this.$root.$t("mall_modules_productlist_fuwu") as string)) {
            item.children = _.concat(item.children, result);
          }
        });
      }
    });
  }
  onConfirm() {
    if (this.serveType == "flight") {
      this.$emit("getFilters", this.flightFilters, this.flightLevelId);
    }
    if (this.serveType == "train") {
      this.$emit("getFilters", this.trainFilters, this.trainPolicy);
    }
    (this as any).$refs.item.toggle();
  }
  showCalende(): void {
    this.isShow = !this.isShow;
  }
  handleSelect(data: any) {
    this.isShow = false;
    let departTime = "";
    if (data instanceof Array) {
      departTime = (this as any).$moment(data[0]).format("YYYY-MM-DD");
    } else {
      departTime = (this as any).$moment(data).format("YYYY-MM-DD");
    }
    this.$emit("chnageTime", departTime);
  }
  // 前一天
  handleUpDay(date: string) {
    const newDate = (this as any)
      .$moment(date)
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.defaultDate = new Date(newDate);
    this.$emit("setDepartTime", newDate);
  }
  //后一天
  handleDownDay(date: string) {
    const newDate = (this as any)
      .$moment(date)
      .add(1, "days")
      .format("YYYY-MM-DD");
    this.defaultDate = new Date(newDate);
    this.$emit("setDepartTime", newDate);
  }
  formatDate(value: Date, format: string = "MM-DD ddd") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  clickItem(data?: any) {
    if (this.activeIds instanceof Array) {
      if (data.id !== 0) {
        _.remove(this.activeIds, item => item === 0);
        if (this.activeIds.length == 0) this.activeIds = [0];
      } else {
        this.activeIds = [0];
      }
      if (this.activeIndex === 3) {
        this.$emit("getFilters", "ServiceLevel", this.activeIds);
      } else if (this.activeIndex === 4) {
        this.$emit("getFilters", "Themes", this.activeIds);
      } else if (this.activeIndex === 5) {
        this.$emit("getFilters", "Facilities", this.activeIds);
      }
    }
    if (this.activeIndex === 0) {
      this.$emit("getFilters", "DistrictId", this.activeIds);
    } else if (this.activeIndex === 1) {
      this.$emit("getFilters", "BusinessId", this.activeIds);
    } else if (this.activeIndex === 2) {
      this.$emit("getFilters", "price", this.activeIds);
    }
  }
  flightClickItem(data?: any) {
    if (this.flightActiveIds instanceof Array) {
      if (data.id !== 0) {
        _.remove(this.flightActiveIds, item => {
          return item === 0;
        });
        if (this.flightActiveIds.length == 0) this.flightActiveIds = [0];
      } else {
        this.flightActiveIds = [0];
      }
      if (this.activeIndex === 0) {
        this.flightFilters.DepartTime = this.flightActiveIds.join(",") != "0" ? this.flightActiveIds.join(",") : "";
      } else if (this.activeIndex === 1) {
        this.flightFilters.DepartAirport = this.flightActiveIds.join(",") != "0" ? this.flightActiveIds.join(",") : "";
      } else if (this.activeIndex === 2) {
        this.flightFilters.ArrivalAirport = this.flightActiveIds.join(",") != "0" ? this.flightActiveIds.join(",") : "";
      } else if (this.activeIndex === 4) {
        this.flightFilters.AirwayCode = this.flightActiveIds.join(",") != "0" ? this.flightActiveIds.join(",") : "";
      } else if (this.activeIndex === 5) {
        this.flightFilters.BtripRules = this.flightActiveIds.join(",") != "3" ? this.flightActiveIds.join(",") : "";
      }
    }
    if (this.activeIndex === 3) {
      this.flightLevelId = this.flightActiveIds != "0" ? this.flightActiveIds : "";
    }
  }
  trainClickItem(data?: any) {
    let optionGroup = this.trainItems[this.activeIndex];
    if (data.mutex) {
      _.forEach(optionGroup.children, (o: any) => _.remove(this.trainActiveIds, item => item === o.id));
      this.trainActiveIds.push(data.id);
    } else {
      let mutexs = _.filter(optionGroup.children, (c: any) => c.mutex);
      _.forEach(mutexs, (o: any) => _.remove(this.trainActiveIds, item => item === o.id && o.id != data.id));
    }
    let activeIds = _.filter(this.trainActiveIds, o => _.find(optionGroup.children, (c: any) => c.id == o));
    _.remove(activeIds, a => a === 0);
    console.log(optionGroup.code);
    let trainFilters = optionGroup.code == "trainPolicy" ? this : (this.trainFilters as any);
    trainFilters[optionGroup.code as string] = activeIds.join(",");

    // if (data.id)
    //   if (this.trainActiveIds instanceof Array) {
    //     // this.trainItems.find(o => data.id);
    //     if (data.id !== 0) {
    //       _.remove(this.trainActiveIds, item => item === 0);
    //       if (this.trainActiveIds.length == 0) this.trainActiveIds = [0];
    //     } else {
    //       this.trainActiveIds = [0];
    //     }
    //     if (this.activeIndex === 0) {
    //       this.trainFilters.trainType = this.trainActiveIds.join(",") != "0" ? this.trainActiveIds.join(",") : "";
    //     } else if (this.activeIndex === 1) {
    //       this.trainFilters.trainDate = this.trainActiveIds.join(",") != "0" ? this.trainActiveIds.join(",") : "";
    //     } else if (this.activeIndex === 3) {
    //       this.trainFilters.fromStation = this.trainActiveIds.join(",") != "0" ? this.trainActiveIds.join(",") : "";
    //     } else if (this.activeIndex === 4) {
    //       this.trainFilters.toStation = this.trainActiveIds.join(",") != "0" ? this.trainActiveIds.join(",") : "";
    //     }
    //   }
    // if (this.activeIndex === 2) {
    //   this.trainPolicy = this.trainActiveIds != "0" ? this.trainActiveIds : "";
    // }
  }
  clickNav(data?: number) {
    if (this.serveType == "hotel") {
      if (data === 3 || data === 4 || data === 5) {
        this.activeIds = [0];
      } else {
        this.activeIds = 0;
      }
    } else if (this.serveType == "flight") {
      if (data != 3) {
        this.flightActiveIds = [0];
        return;
      }
      this.flightActiveIds = 0;
    } else {
      // this.trainActiveIds = [0];
      // if (data != 2) {
      //   this.trainActiveIds = [0];
      //   return;
      // }
      // this.trainActiveIds = 0;
    }
  }
  getNewList() {
    if (this.serveType == "hotel") {
      this.$emit("getNewList", this.hotelKeyWords);
    }
  }
  back() {
    history.back();
  }
  gotoKeyword() {
    let data = {
      Consumers: this.$route.query.Consumers,
      DepartDate: this.$route.query.DepartDate,
      ArriveDate: this.$route.query.ArriveDate,
      ArriveCity: this.$route.query.ArriveCity,
      ArriveCityName: this.$route.query.ArriveCityName,
      BookingType: this.$route.query.BookingType,
      ZoneID: this.$route.query.ZoneID,
      CityName: this.$route.query.ArriveCityName,
    };
    this.$router.push({
      path: "/mall/addKeywords",
      query: data,
    });
  }

  @Watch("filterData", { deep: true })
  handleWatch(newVal: any) {
    if (newVal) {
      if (this.serveType == "train") {
        const toStation = _.map((this as any).filterData.toStation, (item: any) => ({ text: item, id: item }));
        const fromStation = _.map((this as any).filterData.fromStation, (item: any) => ({ text: item, id: item }));
        _.forEach(this.trainItems, item => {
          if (item.text == (this.$root.$t("mall_modules_productlist_chufachezhan") as string)) {
            item.children = _.concat(item.children, fromStation);
          }
          if (item.text == (this.$root.$t("mall_modules_productlist_daodachezhan") as string)) {
            item.children = _.concat(item.children, toStation);
          }
        });
      }
    }
  }
}
